export enum LogLevel {
	TRACE = 1000,
	DEBUG = 2000,
	INFO = 3000,
	WARN = 4000,
	ERROR = 5000,
	FATAL = 6000
}

export enum Appenders {
	console,
	ajax
}

export enum LogAction {
	GetAccounts = 'GetAccounts',
	LoggedIn = 'LoggedIn',
	LoggedOut = 'LoggedOut',
	Authentication = 'Authentication',
	ImageUpload = 'ImageUpload',
	FileUpload = 'FileUpload',
	GraphQlRequest = 'GraphQlRequest',
	Activity = 'Activity',
	Subscription = 'Subscription',
	SideBarImpression = 'SideBarImpression',
	SideBarClick = 'SideBarClick',
	BodyImpression = 'BodyImpression',
	BodyClick = 'BodyClick',
	VideoStarted = 'VideoStarted',
	RegisteredInterest = 'RegisteredInterest',
	RegisteredInPremium = 'RegisteredInPremium',
	RegisteredInterestPremiumChannel = 'RegisteredInterestPremiumChannel',
	ViewPremiumWithoutAccess = 'ViewPremiumWithoutAccess',
	ViewLockedWithoutAccess = 'ViewLockedWithoutAccess',
	DownloadData = 'DownloadData',
	ArticlePrinted = 'ArticlePrinted',
	Appcues = 'Appcues',
	IntelligenceClient = 'IntelligenceClient',
	None = 'None'
}

export enum HttpLoggerOperationType {
	Request = 'GraphQL Request',
	Response = 'GraphQL Response'
}

export interface HttpLoggerRequest {
	operationType: HttpLoggerOperationType;
	operationName: string;
	timeStamp: string; // ISO String
}

export interface HttpLoggerResponse extends HttpLoggerRequest {
	operationTimeMs: number;
}

export interface LogEntry {
	neonUserId: string;
	sessionId: string;
	requestId?: string;
	dateTime: string;
	level: string;
	action: string;
	message: string;
	data?: any;
}

export interface LoggerSessionInfo {
	identity: string;
	sessionId: string;
	dateTime: string;
	level: string;
	message: string;
}


export interface LoggingConfig {
	level: LogLevel;
	appenders: Appenders[];
	addTimeStamp?: boolean;
	endpoint?: string;
	batchTimeoutMs?: number;
	batchSize?: number;
	maxBatchSize?: number;
}
